<script>
import { mapGetters } from 'vuex'
import PassCard from '@components/pass-and-card/pass-card.vue'

export default {
  components: {
    PassCard,
  },
  computed: {
    ...mapGetters('passAndCard', ['pageData']),
    ...mapGetters('translations', ['currentLanguage']),
    gridData() {
      if (
        !this.pageData?.content?.en?.news ||
        !this.pageData?.news_web_images ||
        !this.pageData?.news_urls
      ) {
        return []
      }

      const localizedNews =
        this.pageData.content[this.currentLanguage]?.news || []
      const fallbackNews = this.pageData.content.en.news

      const webImages = this.pageData.news_web_images || []
      const urls = this.pageData.news_urls || []

      return fallbackNews.map((fallbackItem, index) => {
        const localizedItem = localizedNews[index]

        const title = localizedItem?.title || fallbackItem.title
        const text = localizedItem?.text || fallbackItem.text
        const buttonText =
          localizedItem?.news_button_label ||
          fallbackItem.news_button_label ||
          'Learn More'

        const imagePath = webImages[index] || ''

        return {
          _id: index + 1,
          title: title,
          text: text,
          buttonText: buttonText,
          image: [imagePath, ''],
          route: urls[index] || '',
        }
      })
    },
  },
}
</script>

<template>
  <div class="section-container">
    <div class="content">
      <PassCard
        v-for="(article, index) in gridData"
        :key="index"
        :article="article"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.section-container {
  width: 1140px;
}

.content {
  display: grid;
  justify-items: center;
  row-gap: 40px;
  grid-template-columns: repeat(1, 1fr);
  margin-top: 30px;
}

@media only screen and (max-width: $container-width-xs) {
  .section-container {
    width: 100%;
  }

  .content {
    row-gap: 30px;
    margin-top: 20px;
  }
}
</style>
